module.exports = __webpack_public_path__ + "3661f8057905e9fdd0c001818661d87a.svg";